module.exports = __webpack_public_path__ + "img/degree_bgTexture_main.267542a5.png";